import { Injectable } from "@angular/core";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

//const SAVED_USER_SETTINGS = ProfileSettingKeys.userOrderEntrySettings;

@Injectable()
export class OELogSettingsService {
  /**********************************************************************/
  public debug = {
    // generic
    extendedLogging: false,
    dumpModelsLogging: false,
    // rate
    extendedLogging_rate: false,
    dumpModelsLogging_rate: false,
  };

  /**********************************************************************/
  /* CONSTRUCTOR */

  constructor() // eslint-disable-next-line @typescript-eslint/no-empty-function
  {}

  /**********************************************************************/
  /* DEBUG */

  public setExtendedLoggingState(logState: boolean): void {
    this.debug.extendedLogging = logState;
    this.debug.dumpModelsLogging = this.debug.extendedLogging
      ? this.debug.dumpModelsLogging
      : false;
  }
  public getExtendedLoggingState(): boolean {
    return this.debug.extendedLogging;
  }

  public setDumpModelLoggingState(logState: boolean): boolean {
    this.debug.dumpModelsLogging = this.debug.extendedLogging ? logState : false;
    return this.debug.dumpModelsLogging;
  }

  public getDumpModelLoggingState(): boolean {
    return this.debug.dumpModelsLogging;
  }
  // RATE
  public setRateExtendedLoggingState(logState: boolean): void {
    this.debug.extendedLogging_rate = logState;
    this.debug.dumpModelsLogging_rate = this.debug.extendedLogging_rate
      ? this.debug.dumpModelsLogging_rate
      : false;
  }
  public getRateExtendedLoggingState(): boolean {
    return this.debug.extendedLogging_rate;
  }

  public setRateDumpModelLoggingState(logState: boolean): boolean {
    this.debug.dumpModelsLogging_rate = this.debug.extendedLogging_rate ? logState : false;
    return this.debug.dumpModelsLogging_rate;
  }
  public getRateDumpModelLoggingState(): boolean {
    return this.debug.dumpModelsLogging_rate;
  }
}
